import React from "react";
import { Form, Switch } from "@xala/common-ui";
import { useTranslation } from "react-i18next";
import { INotificationField } from "./INotificationField";
import { NotificationStatus } from "@xala/common-services";

export const IsDraftField = ({
  notification,
  isEditMode,
  isHidden,
}: INotificationField) => {
  const { t } = useTranslation();

  if (isHidden) {
    return null;
  }

  return (
    <Form.Item
      name="isDraft"
      key="isDraft"
      label={t("IS_DRAFT_LABEL")}
      valuePropName="checked"
      initialValue={
        isEditMode && notification?.Status === NotificationStatus.Draft
          ? true
          : false
      }
    >
      <Switch
        disabled={
          notification?.Status === NotificationStatus.Sent ||
          notification?.Status === NotificationStatus.InProgress
        }
      />
    </Form.Item>
  );
};
